import { Fragment, ReactNode } from 'react';

interface BasicLayoutProps {
  children: ReactNode;
}

const BasicLayout = ({ children }: BasicLayoutProps) => <Fragment>{children}</Fragment>;

export default BasicLayout;
